<template>
  <div class="alerts">
    <!-- User Icon (Click to Toggle Popup) -->
    <div class="alerts__author-img" @click="togglePopup">
      <i class="fa-regular fa-message"></i>
      <span v-if="alertsCount" class="alerts__count">{{ alertsCount }}</span>
    </div>
    <!-- Popup (Shown When popupVisible is True) -->
    <div v-if="popupVisible" class="alerts__popup" ref="popup">
      <h3 class="alerts__title">Notifications: </h3>
      <!-- Menu -->
      <ul class="alerts__menu">
        <li class="alerts__menu-item" v-for="(alert) in latestAlerts" :key="alert.id">
          <router-link @click="this.popupVisible = false" :to="alertLink(alert)">
            <i v-if="alert.status === 'info'" class="fa-solid fa-circle-info"></i>
            <i v-if="alert.status === 'success'" class="fa-solid fa-circle-check"></i>
            <i v-if="alert.status === 'warning'" class="fa-solid fa-circle-exclamation"></i>
            <i v-if="alert.status === 'error'" class="fa-solid fa-circle-xmark"></i>
            <div class="alerts__meta">
              <div class="alerts__name" :class="{'unread-notification': alert.isRead === 0 }">
                {{ alert.name.length > 20 ? alert.name.slice(0, 20) + '...' : alert.name }}
              </div>
              <div class="alerts__date">{{ format(new Date(alert.createdAt), "yyyy-MM-dd HH:mm:ss") }}</div>
            </div>
          </router-link>
        </li>
      </ul>
      <router-link class="see-all" @click="this.popupVisible = false" to="/notifications">See all notifications</router-link>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "AlertsWidget",
  data() {
    return {
      popupVisible: false,
      alertsCount: false,
      alerts: false
    };
  },
  computed: {
    apiData() {
      return this.$store.getters.getApiData;
    },
    latestAlerts() {
      // Sort alerts by createdAt date (descending) and slice the first 3
      return this.alerts
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 5);
    },
  },
  methods: {
    alertLink(alert) {
      if (alert && alert.link) {
        return alert.link;
      } else {
        return `/notifications/${alert.id}`;
      }
    },
    format,
    togglePopup() {
      this.popupVisible = !this.popupVisible;

      if (this.popupVisible) {
        document.addEventListener("click", this.handleOutsideClick);
      } else {
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    handleOutsideClick(event) {
      // If the click is outside the popup and icon, close it
      if (
        this.$refs.popup &&
        !this.$refs.popup.contains(event.target) &&
        !event.target.closest(".alerts__author-img")
      ) {
        this.popupVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    getAlerts() {
      this.$store.dispatch("getApiCallAction", { hook: '/alerts' })
        .then((res) => {
          this.alerts = res;
        })
        .catch((error) => {
          console.error('Failed to fetch: ', error);
        });
    },
    getCount() {
      this.$store.dispatch("getApiCallAction", { hook: '/alerts/count' })
        .then((res) => {
          this.alertsCount = res.count;
        })
        .catch((error) => {
          console.error('Failed to fetch: ', error);
        });
    },
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  mounted() {
    this.getAlerts();
    this.getCount();
  }
};
</script>
